import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Shared loader for the DB-driven AI model registry. Used by Test Send,
// Content Studio and Content Pool so every generation surface shows the same
// provider/model options (nothing hardcoded).
export function useAiModels() {
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    api.get("/ai/models")
      .then((r) => { if (alive) setModels((r.data.models || []).filter((m) => m.enabled)); })
      .catch(() => { /* leave empty; pages fall back to legacy defaults */ })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);
  return { models, loading };
}

const PROVIDER_LABELS = {
  deepseek_direct: "DeepSeek Direct",
  findclix: "FindClix AI",
};

// Render grouped <optgroup> options from the registry model list.
// `includeRouting` adds a "Routing" group with Weighted + Smart modes.
export function ModelOptions({ models, includeRouting = false }) {
  const byProvider = {};
  for (const m of models) {
    (byProvider[m.provider] = byProvider[m.provider] || []).push(m);
  }
  return (
    <>
      {includeRouting && (
        <optgroup label="Routing (multi-model by weight)">
          <option value="__weighted__">Weighted — spread across ALL models by weight</option>
          <option value="__smart__">Smart — weighted draft + premium escalation</option>
        </optgroup>
      )}
      {Object.keys(byProvider).map((prov) => (
        <optgroup key={prov} label={PROVIDER_LABELS[prov] || prov}>
          {byProvider[prov].map((m) => (
            <option key={m.key} value={m.key}>
              {m.display_name} · {m.role}
            </option>
          ))}
        </optgroup>
      ))}
    </>
  );
}

// A sensible default model key given the loaded registry.
export function defaultModelKey(models) {
  if (!models || models.length === 0) return "deepseek_direct_flash";
  const qwen = models.find((m) => m.key === "findclix_qwen3_30b");
  if (qwen) return qwen.key;
  return models[0].key;
}
